import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import { useState } from "react";
import { Snackbar, Alert } from "@mui/material";

function TextField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");
  // console.log(options);

  return (
    <MDBox>
      <MDBox ml={0.5}>
        <MDTypography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </MDTypography>
      </MDBox>
      <MDInput
        name={fieldRef}
        id={`dff_${fieldRef}`}
        margin="dense"
        // label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        InputLabelProps={{
          sx: {
            whiteSpace: "break-spaces",
          },
        }}
        onBlur={(e) => {
          const entryValue = e.target.value;
          // console.log(options);

          if (typeof options.number_only !== "undefined") {
            if (options.number_only === "true" || options.number_only === "1") {
              const isnum = /^\d+$/.test(entryValue);
              if (!isnum) {
                e.target.value = null;
                setErrMsg(`${displayName} requires only digits`);
                showFieldError(true);
                return;
              }
            }
          }

          if (typeof options.min_length !== "undefined") {
            if (entryValue.length < options.min_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} must be atleast ${options.min_length} long`
              );
              showFieldError(true);
              return;
            }
          }

          if (typeof options.max_length !== "undefined") {
            if (entryValue.length > options.max_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} cannot be longer ${options.max_length} characters`
              );
              showFieldError(true);
              return;
            }
          }

          if (typeof options.allowed_length !== "undefined") {
            if (entryValue.length !== options.allowed_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} must be ${options.allowed_length} long`
              );
              showFieldError(true);
            }
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

// Typechecking props of the Transaction
TextField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

TextField.defaultProps = {
  options: null,
};

export default TextField;
